import React, { useState, useEffect } from 'react';
import { Row, Col, Alert } from 'reactstrap';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { getTranslationKey } from 'helpers/texting';
import { useCloseIconUrl } from './icons/CloseIcon';

const AlertStyled = styled(Alert)<{ $closeIconUrl: string }>`
  .close {
    background-color: #333333 !important;
    vertical-align: middle;
    margin-right: 8px;
    border: none;
    mask-image: url('${(props) => props.$closeIconUrl}');
    -webkit-mask-image: url('${(props) => props.$closeIconUrl}');
    mask-repeat: no-repeat;
    width: 10px;
    height: 10px;

    &:before {
      content: '';
    }

    span {
      display: none;
    }
  }
  background-color: none !important;
`;

interface AlertWrapperProps {
  dismissAppInstallationHint: () => void;
}

const AlertWrapper: React.FC<AlertWrapperProps> = ({ dismissAppInstallationHint }) => {
  const closeIconUrl = useCloseIconUrl();

  return (
    <AlertStyled
      $closeIconUrl={closeIconUrl}
      color="warning"
      isOpen
      onClick={dismissAppInstallationHint}
      toggle={dismissAppInstallationHint}
    >
      {getTranslationKey('appinstallation.alertHint')}
    </AlertStyled>
  );
};

interface UserState {
  appInstallationAlertHint?: boolean;
  appInstallation?: string;
  confirmedPhotoBookReminder?: boolean;
  confirmedSingleImgDlHint?: boolean;
}

interface RootState {
  user: UserState;
}

export const AppInstallationAlertHint: React.FC = () => {
  const user = useSelector((state: RootState) => state.user);
  const [showAppInstallationHint, setShowAppInstallationHint] = useState<boolean>(false);

  const dismissAppInstallationHint = (): void => {
    setShowAppInstallationHint(false);
  };

  useEffect(() => {
    if (user.appInstallationAlertHint === true) {
      setShowAppInstallationHint(true);
      const timeoutId = setTimeout(dismissAppInstallationHint, 8000);

      // Cleanup timeout on unmount
      return () => clearTimeout(timeoutId);
    }
  }, [user.appInstallationAlertHint]);

  return showAppInstallationHint ? (
    <Row className="justify-content-center text-center cursor-pointer">
      <Col xl="3" lg="4" md="12" xs="12" className="app-installation-alert">
        <AlertWrapper dismissAppInstallationHint={dismissAppInstallationHint} />
      </Col>
    </Row>
  ) : null;
};
